import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-splats',
  templateUrl: './manual-splats.component.html',
  styleUrls: ['./manual-splats.component.css'],
  standalone: false,
})
export class ManualSplatsComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
